import Agent from 'models/agent';
import createConverter from './lib/create_converter';

export default createConverter(Agent);



// WEBPACK FOOTER //
// ./src/scripts/application/dto_converters/agent_converter.js